import { useEffect, useState } from "react";
import { KPI_BONUS } from "../metrics.ts";
import { lastMonths } from "../dates.ts";
import { fmtVND } from "../format.ts";
import { toast } from "../toast.ts";
import { Modal } from "./Modal.tsx";
import type { EntryApi } from "../domain.ts";

type SiteUser = { id: number; name: string; email: string };

export type LogKpiModalProps = {
  api: EntryApi;
  isDemo: boolean;
  account: { name: string; username: string } | null;
  onClose: () => void;
  onSaved: () => Promise<void>;
};

export function LogKpiModal({ api, isDemo, account, onClose, onSaved }: LogKpiModalProps) {
  // null = đang tải. Bản cũ await getSiteUsers() TRƯỚC khi mở modal; ở đây
  // modal mở ngay và khoá nút Save cho tới khi có danh sách — nếu không,
  // submit sớm sẽ gửi recruiterId rỗng.
  const [users, setUsers] = useState<SiteUser[] | null>(null);
  const months = lastMonths();

  useEffect(() => {
    let alive = true;
    api.getSiteUsers()
      .then((u) => { if (alive) setUsers(u); })
      .catch(() => { if (alive) setUsers([]); }); // dropdown rỗng vẫn mở được
    return () => { alive = false; };
  }, [api]);

  const me = account?.username;
  const preselected = users?.find((u) => u.email === me)?.id;

  return (
    <Modal
      title="Log KPI Achievement"
      onClose={onClose}
      submitDisabled={users === null}
      onSubmit={async (fd) => {
        await api.addAchievement({
          month: String(fd.get("month") ?? ""),
          recruiterId: Number(fd.get("recruiterId")),
          kpiType: String(fd.get("kpiType") ?? ""),
          title: String(fd.get("title") ?? "").trim(),
        });
        toast(isDemo ? "DEMO — đã thêm vào bộ nhớ (chưa lưu thật)." : "✓ Đã lưu vào SharePoint.");
        await onSaved();
      }}
    >
      <div className="f-row">
        <label className="f-field">
          <span>Month</span>
          <select name="month" defaultValue={months[0]}>
            {months.map((m) => <option value={m} key={m}>{m}</option>)}
          </select>
        </label>
        <label className="f-field">
          <span>Recruiter</span>
          {users === null ? (
            <select name="recruiterId" disabled>
              <option>Đang tải…</option>
            </select>
          ) : (
            <select name="recruiterId" required defaultValue={preselected}>
              {users.map((u) => <option value={u.id} key={u.id}>{u.name}</option>)}
            </select>
          )}
        </label>
      </div>
      <div className="kpi-type-list">
        {Object.entries(KPI_BONUS).map(([type, bonus], i) => (
          <label className="kpi-type" key={type}>
            <input type="radio" name="kpiType" value={type} defaultChecked={i === 0} />
            <span>{type}</span><b>+{fmtVND(bonus)}</b>
          </label>
        ))}
      </div>
      <label className="f-field">
        <span>Candidate / note</span>
        <input type="text" name="title" placeholder="VD: Nguyen Van A — Senior Java" />
      </label>
    </Modal>
  );
}
